import React from "react";
import "../MonopolyPrivacyPolicy/style.css";
import "../CrazyFoxPrivacyPolicy/style.css";
import ContactSpin from "../SpinMasterPrivacyPolicy/ContactSpin";

const CrazyFoxTermsAndConditions = () => {
  return (
    <div
      className="monopoly-policy-main crazy-fox"
      style={{ backgroundColor: "transparent" }}
    >
      <h1>Terms and Conditions For Reward Links for Crazy Fox</h1>
      <p>
        <strong>Last updated: June 08, 2026</strong>
      </p>

      <p>
        By downloading or using the <strong>Reward Links for Crazy Fox</strong>{" "}
        app, these terms will automatically apply to you – you should make sure
        therefore that you read them carefully before using the app.
      </p>

      <h2>1. Terms of Use</h2>
      <p>
        You’re not allowed to copy or modify the app, any part of the app, or
        our trademarks in any way. You’re not allowed to attempt to extract the
        source code of the app, and you also shouldn’t try to translate the app
        into other languages or make derivative versions. The app itself, and
        all the trademarks, copyright, database rights, and other intellectual
        property rights related to it, still belong to the developer.
      </p>

      <h2>2. App Modifications and Charges</h2>
      <p>
        We are committed to ensuring that the app is as useful and efficient as
        possible. For that reason, we reserve the right to make changes to the
        app or to charge for its services, at any time and for any reason. We
        will never charge you for the app or its services without making it very
        clear to you exactly what you’re paying for.
      </p>

      <h2>3. Disclaimer of Affiliation</h2>
      <p>
        This Application operates independently as an unofficial helper tool. We
        are in no way affiliated, associated, authorized, endorsed by, or in any
        way officially connected with ASTAK TECH or the original creators of the
        Crazy Fox game. All names, logos, images, and registered trademarks
        remain the property of their respective owners.
      </p>

      <h2>4. Virtual Items and Rewards</h2>
      <p>
        All reward links and promotional items featured within this Application
        are gathered from public domains and official social channels. We cannot
        ensure the continuous availability or validity of these rewards, as they
        are entirely managed by the game's official developers and are subject
        to expiration.
      </p>
      <p>
        <strong>Apple Disclaimer:</strong> Please note that Apple Inc. does not
        sponsor, endorse, and is not involved in any manner with the promotions,
        rewards, or virtual items offered through this Application.
      </p>

      <h2>5. Personal Data and Security</h2>
      <p>
        The <strong>Reward Links for Crazy Fox</strong> app stores and processes
        personal data that you have provided to us, to provide our Service, as
        well as data used by third-party services (like Analytics, AdMob, and
        Firebase Cloud Messaging) as described in our Privacy Policy. It’s your
        responsibility to keep your phone and access to the app secure. We
        therefore recommend that you do not jailbreak or root your phone.
      </p>

      <h2>6. Network and Connectivity</h2>
      <p>
        You should be aware that there are certain things that the developer
        will not take responsibility for. Certain functions of the app will
        require the app to have an active internet connection. The connection
        can be Wi-Fi or provided by your mobile network provider, but the
        developer cannot take responsibility for the app not working at full
        functionality if you don’t have access to Wi-Fi, and you don’t have any
        of your data allowance left.
      </p>
      <p>
        If you’re using the app outside of an area with Wi-Fi, you should
        remember that the terms of the agreement with your mobile network
        provider will still apply. As a result, you may be charged by your
        mobile provider for the cost of data for the duration of the connection
        while accessing the app, or other third-party charges. In using the app,
        you’re accepting responsibility for any such charges.
      </p>

      <h2>7. Developer Responsibility</h2>
      <p>
        With respect to our responsibility for your use of the app, when you’re
        using the app, it’s important to bear in mind that although we endeavor
        to ensure that it is updated and correct at all times, we do rely on
        third parties to provide information to us so that we can make it
        available to you. The developer accepts no liability for any loss,
        direct or indirect, you experience as a result of relying wholly on this
        functionality of the app.
      </p>

      <h2>8. User Conduct</h2>
      <p>
        You agree to use the app only for lawful purposes. You are strictly prohibited from using bots, exploits, automated scripts, or any unauthorized third-party software to modify or interfere with the app's functionality or to extract rewards. We reserve the right to suspend or terminate access for any user found violating these rules.
      </p>

      <h2>9. Advertising and Third-Party Links</h2>
      <p>
        The Application may contain third-party advertisements and links to external websites. We do not endorse or assume any responsibility for the content, privacy policies, or practices of any third-party websites or services. Your interactions with advertisers found within the app are solely between you and the advertiser.
      </p>

      <h2>10. Limitation of Liability and Indemnification</h2>
      <p>
        The Application is provided on an "AS IS" and "AS AVAILABLE" basis. To the fullest extent permitted by applicable law, the developer shall not be liable for any direct, indirect, incidental, or consequential damages resulting from your use or inability to use the app. You agree to indemnify and hold harmless the developer from any claims, losses, or damages arising from your use of the Application.
      </p>

      <h2>11. Termination</h2>
      <p>
        We reserve the right to suspend or terminate your access to the Application at any time, without prior notice or liability, for any reason whatsoever, including without limitation if you breach these Terms and Conditions.
      </p>

      <h2>12. Changes to This Terms and Conditions</h2>
      <p>
        We may update our Terms and Conditions from time to time. Thus, you are
        advised to review this page periodically for any changes. We will notify
        you of any changes by posting the new Terms and Conditions on this page.
      </p>

      <h2>13. Contact Us</h2>
      <p>
        If you have any questions or suggestions about our Terms and Conditions,
        do not hesitate to contact us at:
      </p>
      <ContactSpin isMonopoly={true} />
    </div>
  );
};

export default CrazyFoxTermsAndConditions;
